export enum ClubRoles {
    Member = 1,
    Admin = 2,
    Animator = 3,
}
